export const baseURL ="https://wowfy.in/wowfy_app_codebase/api/admin";
export const baseImgURL ="https://wowfy.in/wowfy_app_codebase/photos/";
export const baseVidUrl ="https://wowfy.in/wowfy_app_codebase/videos/";
// export const baseURL ="http://192.168.1.40/Zen/wowfy-location/api/admin";
// export const baseImgURL ="http://192.168.1.40/Zen/wowfy-location/photos/";
// export const baseVidUrl ="http://192.168.1.40/Zen/wowfy-location/videos/";
